import React, { FC } from "react";
import { blueGrey } from "@mui/material/colors";
import { Typography, Button } from "@mui/material";
import GetAppIcon from "@mui/icons-material/GetApp";
import { styled } from "@mui/material/styles";
import useSignSuccessSelector from "./useSignSuccessSelector";

const StyledParentDiv = styled("div")({
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const StyledChildDiv = styled("div")({
  backgroundColor: blueGrey[50],
  border: "3px solid grey",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  width: 600,
  borderRadius: 20,
  position: "fixed",
  top: "30%",
});

const StyledInfoDiv = styled("div")({
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  paddingBottom: 20,
  paddingTop: 10,
});

const SignSuccessPage: FC = () => {
  const { handleClick, fileName, dloadURL, user } = useSignSuccessSelector();

  if (!user) {
    <StyledParentDiv>
      <StyledChildDiv>
        <Typography style={{ color: "red" }}>
          An Error Occurred. Please Try Refreshing the Page.
        </Typography>
      </StyledChildDiv>
    </StyledParentDiv>;
  }

  return (
    <StyledParentDiv>
      <StyledChildDiv>
        <div style={{ borderBottom: "1px solid black" }}>
          <Typography variant="h6" style={{ fontWeight: "bold" }}>
            Thank You! Your Order has been Submitted.
          </Typography>
        </div>
        <StyledInfoDiv>
          <img
            style={{ height: 100, width: 400 }}
            src="https://res.cloudinary.com/ag-millworks/image/upload/AG_Logos/AGlogoBlack.png"
            alt="logo"
          />
          <Typography style={{ padding: 20 }}>
            You will recieve an email with the signed documents.
          </Typography>
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <a
              href={dloadURL}
              download={fileName}
              style={{ textDecoration: "none", marginRight: 5 }}
            >
              <Button variant="contained" color="primary">
                <GetAppIcon />
                Download Signed PDF
              </Button>
            </a>
            <Button
              style={{ marginLeft: 5 }}
              variant="contained"
              color="cyan"
              onClick={handleClick}
            >
              Return to Dealer Zone
            </Button>
          </div>
        </StyledInfoDiv>
      </StyledChildDiv>
    </StyledParentDiv>
  );
};

export default SignSuccessPage;
